"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _reactLazyLoadImageComponent = require("react-lazy-load-image-component");
var _commonLibs = require("@mmc/common-libs");
var _clsx = _interopRequireDefault(require("clsx"));
var _objectFitImages = _interopRequireDefault(require("object-fit-images"));
var _commonMedia = _interopRequireDefault(require("../styles/common-media.css"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var _DataUtils = new _mmcDataUtilities["default"](),
  appendImageOptimization = _DataUtils.appendImageOptimization;
var IMAGE_WIDTH = 2160;
var BackgroundImage = function BackgroundImage(_ref) {
  var image = _ref.image,
    altText = _ref.altText,
    size = _ref.size,
    sizes = _ref.sizes,
    imageQuality = _ref.imageQuality,
    classes = _ref.classes;
  var ref = (0, _react.useRef)();
  var width = size || IMAGE_WIDTH;
  var isBackground = false;
  var isWebp = true;
  var srcSet = [appendImageOptimization(image, 240, isBackground, isWebp, imageQuality) + " 240w", appendImageOptimization(image, 480, isBackground, isWebp, imageQuality) + " 480w", appendImageOptimization(image, 720, isBackground, isWebp, imageQuality) + " 720w", appendImageOptimization(image, 1080, isBackground, isWebp, imageQuality) + " 1080w", appendImageOptimization(image, 1440, isBackground, isWebp, imageQuality) + " 1440w", appendImageOptimization(image, 2160, isBackground, isWebp, imageQuality) + " 2160w"].join(',');
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      height: 'inherit'
    },
    ref: ref
  }, /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
    afterLoad: function afterLoad() {
      return (0, _commonLibs.execIE11ImagePolyfills)(ref, _objectFitImages["default"]);
    },
    className: (0, _clsx["default"])(_commonMedia["default"].backgroundImage, classes),
    src: appendImageOptimization(image, width, isBackground, isWebp, imageQuality),
    srcSet: srcSet,
    sizes: sizes || '100vw',
    alt: altText
  }));
};
BackgroundImage.defaultProps = {
  imageQuality: 70
};
var _default = BackgroundImage;
exports["default"] = _default;